export default "__VITE_ASSET__c6fbf08d__"